(() => {
  if (window.AvessoraCart) return;
  let active = false;
  let revision = 0;
  let previousFocus;
  let scrollStyle = '';
  const root = () => document.querySelector('[data-avcd]');
  const announceError = message => {
    const drawer = root();
    if (!drawer) return;
    const error = drawer.querySelector('[data-avcd-error]');
    error.textContent = message || drawer.dataset.errorText;
    error.hidden = false;
  };
  const syncHeader = () => {
    const drawer = root();
    if (!drawer) return;
    document.querySelectorAll('.av-tools a[href]').forEach(link => {
      if (new URL(link.href).pathname !== drawer.dataset.cartUrl) return;
      let badge = link.querySelector('.av-bag-count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'av-bag-count'; link.append(badge); }
      badge.textContent = drawer.dataset.count;
      badge.hidden = Number(drawer.dataset.count) === 0;
    });
    document.querySelectorAll('[data-testid="cart-drawer-trigger"]').forEach(button => button.setAttribute('aria-controls','AvessoraCartDrawer'));
    document.querySelectorAll('cart-icon').forEach(icon => {
      icon.classList.toggle('header-actions__cart-icon--has-cart',Number(drawer.dataset.count)>0);
      icon.querySelectorAll('.cart-bubble__text-count').forEach(badge=>badge.textContent=drawer.dataset.count);
      icon.querySelectorAll('.cart-bubble').forEach(badge=>badge.hidden=Number(drawer.dataset.count)===0);
    });
  };
  const open = () => {
    const drawer = root();
    if (!drawer || drawer.open) return;
    previousFocus = document.activeElement;
    scrollStyle = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    drawer.showModal();
    drawer.querySelector('[data-avcd-close]').focus({preventScroll:true});
  };
  const close = () => {
    const drawer = root();
    if (!drawer) return;
    drawer.close();
    document.documentElement.style.overflow = scrollStyle;
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
  };
  const render = html => {
    const drawer = root();
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-avcd]');
    if (!parsed || !drawer) throw new Error(drawer?.dataset.errorText);
    const position = drawer.querySelector('.avcd-scroll').scrollTop;
    drawer.innerHTML = parsed.innerHTML;
    for (const attribute of parsed.attributes) {
      if (attribute.name !== 'open') drawer.setAttribute(attribute.name, attribute.value);
    }
    drawer.querySelector('.avcd-scroll').scrollTop = position;
    syncHeader();
  };
  const refresh = async (force = false) => {
    const drawer = root();
    const requestedRevision = revision;
    const url = new URL(drawer.dataset.rootUrl, location.origin);
    url.searchParams.set('section_id', drawer.dataset.sectionId);
    const response = await fetch(url, {headers:{'Accept':'text/html'},cache:'no-store'});
    if (!response.ok) throw new Error(drawer.dataset.errorText);
    const html = await response.text();
    if (requestedRevision === revision && (force || !active)) render(html);
  };
  const busy = state => {
    const drawer = root();
    drawer.setAttribute('aria-busy', String(state));
    drawer.querySelectorAll('[data-avcd-delta],[data-avcd-quantity],[data-avcd-remove],.avcd-checkout').forEach(control => control.disabled = state);
  };
  const request = async (endpoint, payload) => {
    if (active) return;
    active = true;
    revision++;
    busy(true);
    root().querySelector('[data-avcd-error]').hidden = true;
    try {
      const drawer = root();
      const response = await fetch(drawer.dataset.rootUrl + 'cart/' + endpoint + '.js', {
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({...payload,sections:[drawer.dataset.sectionId],sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.errorText);
      const html = data.sections?.[drawer.dataset.sectionId];
      if (html) render(html); else await refresh(true);
      return data;
    } catch (error) {
      announceError(error.message);
      throw error;
    } finally { active = false; busy(false); }
  };
  const add = async (items, form) => {
    const button = form?.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); }
    try { await request('add',{items}); open(); }
    catch (error) {
      const field = form?.querySelector('[data-cart-error]');
      if (field) {field.textContent = error.message;field.hidden = false;} else {open();}
    } finally { if (button?.isConnected) {button.disabled=false;button.removeAttribute('aria-busy');} }
  };
  window.AvessoraCart = {open,close,refresh,add};
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !root()) return;
    const url = new URL(form.action, location.origin);
    if (!/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (active || !form.reportValidity()) return;
    const bundle = [...form.querySelectorAll('[data-bundle-items] select')];
    let items;
    if (bundle.length) items = bundle.map(select => ({id:select.value,quantity:1}));
    else {
      const data = new FormData(form);
      const properties = {};
      for (const [key,value] of data.entries()) { const match=key.match(/^properties\[(.+)\]$/); if(match) properties[match[1]]=value; }
      const item = {id:data.get('id'),quantity:Number(data.get('quantity') || 1),properties};
      if(data.get('selling_plan')) item.selling_plan=data.get('selling_plan');
      items=[item];
    }
    if (items.some(item => !item.id || item.quantity < 1)) return;
    add(items,form);
  },true);
  window.addEventListener('click', event => {
    const drawer = root();
    if (!drawer || !(event.target instanceof Element)) return;
    if(event.target.closest('[data-testid="cart-drawer-trigger"]')) {
      event.preventDefault();event.stopImmediatePropagation();open();refresh().catch(error=>announceError(error.message));return;
    }
    const cartLink = event.target.closest('a[href]');
    if (cartLink && !drawer.contains(cartLink) && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button===0) {
      const url = new URL(cartLink.href);
      if(url.origin===location.origin && url.pathname===drawer.dataset.cartUrl && !cartLink.hasAttribute('data-avcd-page-link')) {
        event.preventDefault();event.stopImmediatePropagation();open();refresh().catch(error=>announceError(error.message));return;
      }
    }
    if (!drawer.open) return;
    if(event.target.closest('[data-avcd-close]') || event.target===drawer) {event.preventDefault();event.stopImmediatePropagation();close();return;}
    const control = event.target.closest('[data-avcd-delta],[data-avcd-remove]');
    if (!control || !drawer.contains(control)) return;
    event.preventDefault();event.stopImmediatePropagation();
    if(active)return;
    const row = control.closest('[data-line-key]');
    const input = row.querySelector('[data-avcd-quantity]');
    const increment = Number(input.step || 1);
    let quantity = control.hasAttribute('data-avcd-remove') ? 0 : Number(input.value) + Number(control.dataset.avcdDelta) * increment;
    if(quantity>0 && quantity<Number(input.min))quantity=Number(input.min);
    request('change',{id:row.dataset.lineKey,quantity}).then(()=>root().querySelector(`[data-line-key="${CSS.escape(row.dataset.lineKey)}"] [data-avcd-quantity]`)?.focus({preventScroll:true})).catch(()=>{});
  },true);
  const updateQuantity = event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-avcd-quantity]')) return;
    event.stopImmediatePropagation();
    const input = event.target;
    if (!input.reportValidity() || active || input.value===input.defaultValue) return;
    request('change',{id:input.closest('[data-line-key]').dataset.lineKey,quantity:Number(input.value)}).catch(()=>{});
  };
  window.addEventListener('change',updateQuantity,true);
  window.addEventListener('focusout',updateQuantity,true);
  document.addEventListener('cancel', event => {if(event.target===root()){event.preventDefault();close();}},true);
  document.addEventListener('shopify:section:load', event => {if(event.target.querySelector('[data-avcd]'))open();});
  document.addEventListener('shopify:section:select', event => {if(event.target.querySelector('[data-avcd]'))open();});
  document.addEventListener('shopify:block:select', event => {if(event.target.closest('[data-avcd]'))open();});
  syncHeader();
})();
